// Tiny local replacement for the few date-fns format strings we use across
// the Discover and Explore routes. Pulling in date-fns required loading a
// large prebundled chunk that intermittently 504s in the dev sandbox and
// caused "Failed to fetch dynamically imported module" on Match/Explore.
//
// Only the patterns we actually need are supported:
//   - "MMM d"        → "Apr 25"
//   - "MMM d, yyyy"  → "Apr 25, 2026"

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export function format(date: Date, pattern: "MMM d" | "MMM d, yyyy"): string {
  const m = MONTHS[date.getMonth()];
  const d = date.getDate();
  if (pattern === "MMM d, yyyy") return `${m} ${d}, ${date.getFullYear()}`;
  return `${m} ${d}`;
}